'use client'

import {PifflBox} from '@/types/box/PifflBox'
import dynamic from 'next/dynamic'
import React from 'react'

const BoxMap = dynamic(() => import('./BoxMap'), {
  ssr: false,
})

interface Props {
  box: PifflBox
}

export const BoxMapWrapper: React.FC<Props> = ({box}) => {
  return <BoxMap box={box} />
}
